import { DayOfYearChartReportModel } from "@agroyaar/sdk";
import LineChart from "@/shared/components/charts/LineChart";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import NoteBox from "@/shared/components/report-template/presentation/components/common/NoteBox";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";

interface DailyTemperatureChangeProps {
  dailyMaximumTemperatureChange: DayOfYearChartReportModel[];
  dailyMinimumTemperatureChange: DayOfYearChartReportModel[];
  dailyMeanTemperatureChange: DayOfYearChartReportModel[];
}

const DailyTemperatureChange = ({
  dailyMaximumTemperatureChange,
  dailyMeanTemperatureChange,
  dailyMinimumTemperatureChange,
}: DailyTemperatureChangeProps) => {
  const dayOfYears = dailyMeanTemperatureChange.map((t) =>
    t.dayOfYear.toString()
  );

  const series = [
    {
      name: "حداکثر دما",
      data: dailyMaximumTemperatureChange.map((t) => t.value),
    },
    {
      name: "میانگین دما",
      data: dailyMeanTemperatureChange.map((t) => t.value),
    },
    {
      name: "حداقل دما",
      data: dailyMinimumTemperatureChange.map((t) => t.value),
    },
  ];

  const minMax = (arr: DayOfYearChartReportModel[]) => {
    const values = arr.map((t) => t.value);
    return { min: Math.min(...values), max: Math.max(...values) };
  };

  const formatShowNumber = (number: number) => {
    const rounded = Number(number).toFixed(0);
    if (number < 0) {
      return rounded.replace("-", "") + "-";
    }
    return rounded;
  };

  const minTemp = minMax(dailyMinimumTemperatureChange);
  const maxTemp = minMax(dailyMaximumTemperatureChange);
  const meanTemp = minMax(dailyMeanTemperatureChange);

  const noteText = `
  روند میانگین تغییرات دما در سه دهه گذشته نشان می‌دهد که
  محدوده دمای حداقل از حدود ${formatShowNumber(
    minTemp.min
  )} تا ${formatShowNumber(minTemp.max)} درجه سانتی‌گراد،
  دمای حداکثر از حدود ${formatShowNumber(maxTemp.min)} تا ${formatShowNumber(
    maxTemp.max
  )} درجه سانتی‌گراد
  و متوسط دما بین تقریباً ${formatShowNumber(
    meanTemp.min
  )} تا ${formatShowNumber(meanTemp.max)} درجه سانتی‌گراد متغیر بوده است.
`;

  return (
    <ReportTemplate serviceType="CROPPING_PATTERN" pageNumber={6}>
      <div className="w-full flex flex-col gap-3">
        <Title>روند تغییرات دمای روزانه بر اساس میانگین 30 سال گذشته</Title>
        <div className="w-full flex flex-col justify-center items-center gap-4 my-10">
          <LineChart
            yAxisTitle="(درجه سانتی گراد)دما"
            xAxisTitle="روز در سال"
            xAxisLabelsOptionsStep={30}
            labelsFontSize="10px"
            categories={dayOfYears}
            series={series}
          />

          <Title>
            روند تغییرات حداقل، حداکثر و متوسط دمای روزانه بر اساس میانگین 30
            سال گذشته ایستگاه
          </Title>
        </div>
      </div>
      <NoteBox>{noteText}</NoteBox>
    </ReportTemplate>
  );
};

export default DailyTemperatureChange;
